<script setup lang="ts">

import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import { useNewsStore } from '@/stores/newsStore.ts'
import NewsNotificationBlocked from '@/components/Sections/News/Notifications/NewsBlocked/NewsNotificationBlocked.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Stores
 */
const newsStore = useNewsStore();

</script>

<template>
  <StandardCard :title="t('news.notifications.title')" class="pb-2" :help="t('news.notifications.help')">
    <template v-for="newsType in newsStore.newsTypes.values()" :key="newsType.newsType">
      <NewsNotificationBlocked :news-type="newsType.newsType" :status="newsType.status"/>
    </template>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>